var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgComponentsMenuIcon = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.61511 7.84081C9.20619 7.84081 8.83281 7.56712 8.72296 7.15358L7.60605 2.93004C7.4759 2.43712 7.76943 1.93174 8.26235 1.80158C8.75619 1.67051 9.26019 1.96497 9.3908 2.45789L10.5077 6.68143C10.6379 7.17435 10.3443 7.67974 9.85141 7.80989C9.77249 7.83066 9.6931 7.84081 9.61511 7.84081Z",
    fill: "#EBEBF9",
    stroke: "#EBEBF9",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.91744 10.5399C6.83944 10.5399 6.76005 10.5302 6.68067 10.509L2.45763 9.3916C1.96518 9.26098 1.67118 8.75606 1.80133 8.26314C1.93149 7.77068 2.43456 7.47483 2.92978 7.60683L7.15282 8.72421C7.64528 8.85483 7.93927 9.35975 7.80912 9.85267C7.7002 10.2667 7.32636 10.5399 6.91744 10.5399Z",
    fill: "#EBEBF9",
    stroke: "#EBEBF9",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.3061 18.4239C23.2281 18.4239 23.1487 18.4142 23.0693 18.393L18.8463 17.2756C18.3538 17.145 18.0599 16.64 18.19 16.1471C18.3202 15.6546 18.8228 15.3588 19.3185 15.4908L23.5415 16.6082C24.0339 16.7388 24.3279 17.2437 24.1978 17.7366C24.0884 18.1506 23.715 18.4239 23.3061 18.4239Z",
    fill: "#EBEBF9",
    stroke: "#EBEBF9",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.4994 24.2296C17.0905 24.2296 16.7171 23.9559 16.6072 23.5423L15.4903 19.3193C15.3602 18.8263 15.6537 18.321 16.1466 18.1908C16.6409 18.0593 17.1445 18.3542 17.2751 18.8471L18.392 23.0702C18.5221 23.5631 18.2286 24.0685 17.7357 24.1987C17.6568 24.2194 17.5774 24.2296 17.4994 24.2296Z",
    fill: "#EBEBF9",
    stroke: "#EBEBF9",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M18.2213 14.5756C17.985 14.5756 17.7491 14.4856 17.5687 14.3051C17.2082 13.9447 17.2082 13.3603 17.5687 12.9994L23.4246 7.14435C23.7851 6.78435 24.3694 6.78389 24.7298 7.14435C25.0903 7.50481 25.0903 8.08912 24.7298 8.45004L18.8739 14.3056C18.6934 14.4856 18.4571 14.5756 18.2213 14.5756Z",
    fill: "#EBEBF9",
    stroke: "#EBEBF9",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M24.0766 8.72096C23.8403 8.72096 23.6045 8.63096 23.424 8.4505L17.5492 2.57558C17.1887 2.21512 17.1887 1.63081 17.5492 1.27035C17.9096 0.909885 18.4939 0.909885 18.8544 1.27035L24.7292 7.14527C25.0897 7.50573 25.0897 8.09004 24.7292 8.4505C24.5488 8.6305 24.3129 8.72096 24.0766 8.72096Z",
    fill: "#EBEBF9",
    stroke: "#EBEBF9",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3473 8.70158C12.111 8.70158 11.8751 8.61158 11.6947 8.43112C11.3342 8.07065 11.3342 7.48635 11.6947 7.12588L17.5492 1.27035C17.9097 0.909885 18.494 0.909885 18.8544 1.27035C19.2149 1.63081 19.2149 2.21512 18.8544 2.57558L12.9999 8.43112C12.8194 8.61111 12.5836 8.70158 12.3473 8.70158Z",
    fill: "#EBEBF9",
    stroke: "#EBEBF9",
    strokeWidth: 0.5
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79698 24.9999C7.56067 24.9999 7.32483 24.9099 7.14437 24.7294C6.78391 24.369 6.78391 23.7847 7.14437 23.4242L12.9998 17.5687C13.3603 17.2082 13.9446 17.2082 14.3051 17.5687C14.6655 17.9291 14.6655 18.5134 14.3051 18.8739L8.44959 24.7294C8.26913 24.9099 8.03282 24.9999 7.79698 24.9999Z",
    fill: "#EBEBF9",
    stroke: "#EBEBF9",
    strokeWidth: 0.5
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M7.7969 24.9999C7.56059 24.9999 7.32475 24.9099 7.14429 24.7294L1.27035 18.8554C0.909887 18.495 0.909887 17.9107 1.27035 17.5502C1.6308 17.1897 2.21511 17.1897 2.57556 17.5502L8.44951 23.4247C8.80997 23.7851 8.80997 24.3694 8.44951 24.7299C8.26905 24.9099 8.03274 24.9999 7.7969 24.9999Z",
    fill: "#EBEBF9",
    stroke: "#EBEBF9",
    strokeWidth: 0.5
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M1.92295 19.1254C1.68665 19.1254 1.45081 19.0354 1.27035 18.8549C0.909887 18.4945 0.909887 17.9102 1.27035 17.5497L7.12537 11.6942C7.48582 11.3337 8.07013 11.3337 8.43058 11.6942C8.79104 12.0546 8.79104 12.6389 8.43058 12.9994L2.57556 18.8554C2.3951 19.0354 2.15926 19.1254 1.92295 19.1254Z",
    fill: "#EBEBF9",
    stroke: "#EBEBF9",
    strokeWidth: 0.5
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgComponentsMenuIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/componentsMenuIcon.aacc587e8d2340acffcd86c094c9ba66.svg";